class AuthService {
  signIn(provider) {
    console.log(`Redirecting to ${provider} OAuth`);
    window.location.href = `/api/oauth/${provider}?app=di`;
  }

  async signOut() {
    try {
      sessionStorage.removeItem("auth_token");
    } catch (error) {
      console.error("Sign out error:", error);
      throw error;
    }
  }

  async handleOAuthCallback() {
    try {
      // Read JWT from cookie (assuming it's named 'auth_token')
      const token = this.getCookie("auth_token");

      if (token) {
        sessionStorage.setItem("auth_token", token);
        // Clear the cookie
        document.cookie =
          "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        return true;
      }
      return false;
    } catch (error) {
      console.error("OAuth callback error:", error);
      throw error;
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    return null;
  }

  isAuthenticated() {
    const token = sessionStorage.getItem("auth_token");
    if (!token) return false;

    try {
      // Basic JWT validation (check if expired)
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  }

  async getCurrentUser() {
    const token = sessionStorage.getItem("auth_token");
    if (!token) throw new Error("No authentication token");

    const response = await fetch("/api/oauth/me", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        this.signOut();
      }
      throw new Error("Failed to get user info");
    }

    return response.json();
  }

  getAuthHeader() {
    const token = sessionStorage.getItem("auth_token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
}

export default new AuthService();
